// Plausible event helper. The script in index.html exposes a global
// `plausible(eventName, { props })`. We wrap it so call sites stay terse
// and so the app keeps working in environments where the script never
// loads (ad blocker, dev with offline plausible.io, etc.).
export function track(eventName, props) {
  try {
    if (typeof window === 'undefined') return
    if (typeof window.plausible !== 'function') return
    window.plausible(eventName, props ? { props } : undefined)
  } catch {
    // Analytics must never break the app.
  }
}

// Canonical event names. Strings must match Plausible goal config exactly
// (capitalisation, spacing). The funnel only works if names line up.
export const Events = {
  // Acquisition
  SignupCompleted: 'Signup Completed',
  LandingCtaClicked: 'Landing CTA Clicked',
  LandingScrollDepth: 'Landing Scroll Depth',
  // Group flow
  GroupCreated: 'Group Created',
  GroupJoined: 'Group Joined',
  PicksSubmitted: 'Picks Submitted',
  // Action / aha
  WheelSpun: 'Wheel Spun',
  PickRevealed: 'Pick Revealed',
  SoloPickCompleted: 'Solo Pick Completed',
  // Engagement / retention
  RatingSubmitted: 'Rating Submitted',
  MovieWatched: 'Movie Watched',
  WatchlistAdded: 'Watchlist Added',
  // Virality
  LinkShared: 'Link Shared',
  ResultShared: 'Result Shared',
  SharedLinkViewed: 'Shared Link Viewed',
  LandingCtaClicked: 'Landing CTA Clicked',
  LandingScrollDepth: 'Landing Scroll Depth',
}
